import { swup } from '../main'
import { BoneModal } from './BoneModal';

const baseClass = 'sidebar-nav';
const baseClassPrimary = 'header-menu--primary';

const SidebarNav = (() => {

	const sn = {
		root: undefined,
		rootPrimary: undefined,
		modal: undefined,
	}


	sn.init = function() {
		const root = document.querySelector(`.${baseClass}`);
		const rootPrimary = document.querySelector(`.${baseClassPrimary}`);
		if (!root) {
			return;
		}

		sn.root = root;

		root.addEventListener('click', sn.subnavListener);
		root.addEventListener('click', sn.onNavigation);

		if(rootPrimary) {
			sn.rootPrimary = rootPrimary;
			rootPrimary.addEventListener('click', sn.onPrimaryNavigation);
		}

		const modalElem = document.getElementById('sidebar-nav');
		if (modalElem) {
			sn.modal = new BoneModal(modalElem);
		}

		sn.setupDeepLinks();
	}

	sn.onPrimaryNavigation = (e) => {

		const link = e.target.closest('a');
		if (link) {
			const id = link.dataset.id;
			const sameLink = sn.root.querySelector(`button[data-id="${id}"]`);

			if (sameLink) {
				e.preventDefault();

				document.querySelector('.menu-trigger').click();
				sameLink.click();
			} else {
				swup.loadPage({
					url: link.href,
				});
			}
		}
	}

	sn.onNavigation = function(e) {
		const link = e.target.closest('a');
		if (link) {
			if (sn.modal) {
				sn.modal.close();
			}
			sn.closeAllSubmenus();
		}
	}

	sn.subnavListener = function(e) {
		const clickTarget = e.target;
		if (sn.isSubmenuOpenTrigger(clickTarget)) {
			sn.openSubmenu(sn.getSubmenuOpenTriggerId(clickTarget));
		}
		else if (sn.isSubmenuCloseTrigger(clickTarget)) {
			sn.closeSubmenu(sn.getSubmenuCloseTriggerId(clickTarget));
		}
	}

	sn.openSubmenu = function(id) {
		if (!id) {
			return;
		}

		const submenu = sn.getSubmenu(id);
		if (submenu) {
			submenu.setAttribute('aria-hidden', 'false');

			// For setting state on parent's panel
			const parent = sn.getSubmenuParent(id);
			const panel = sn.getPanel(parent);
			if (panel) {
				panel.setAttribute('data-subpanel-visible', 'true');
			}
		}
	}

	sn.closeSubmenu = function(id) {
		if (!id) {
			return;
		}

		const submenu = sn.getSubmenu(id);
		if (submenu) {
			submenu.setAttribute('aria-hidden', 'true');

			// For setting state on parent's panel
			const parent = sn.getSubmenuParent(id);
			const panel = sn.getPanel(parent);
			if (panel) {
				panel.setAttribute('data-subpanel-visible', 'false');
			}
		}
	}


	sn.isSubmenuCloseTrigger = function(elem) {
		return sn.getSubmenuCloseTriggerId(elem);
	}

	sn.isSubmenuOpenTrigger = function(elem) {
		return sn.getSubmenuOpenTriggerId(elem);
	}

	sn.getSubmenuCloseTriggerId = function(elem) {
		const closeElem = elem.closest('[data-submenu-close]'); // in case click target is a child elem
		return closeElem ? closeElem.getAttribute('data-submenu-close') : '';
	}

	sn.getSubmenuOpenTriggerId = function(elem) {
		const openElem = elem.closest('[data-submenu-open]'); // in case click target is a child elem
		return openElem ? openElem.getAttribute('data-submenu-open') : '';
	}

	sn.getSubmenuParent = function(submenu_id) {
		return sn.root.querySelector(`[data-submenu-parent="${submenu_id}"]`);
	}

	sn.getSubmenu = function(submenu_id) {
		return sn.root.querySelector(`[data-submenu="${submenu_id}"]`);
	}

	sn.getPanel = function(elem) {
		return elem.closest(`.${baseClass}__panel`);
	}

	sn.closeAllSubmenus = function() {
		const submenus = Array.from(sn.root.querySelectorAll('[data-submenu]'));
		if (submenus && submenus.length) {
			submenus.forEach(submenu => {
				const id = submenu.getAttribute('data-submenu');
				sn.closeSubmenu(id);
			});
		}
	}

	sn.setupDeepLinks = function() {
		// TODO: rearchitect this so it doesn't require matching by strings
		const menuIds = {
			shop: findDeepLinkIdByTitle('shop'),
			collections: findDeepLinkIdByTitle('collections'),
		}

		document.body.addEventListener('click', (e) => {
			let id = undefined;
			let isTrigger = false;
			if (e.target.hasAttribute('data-shop-menu-trigger')) {
				id = menuIds.shop;
				isTrigger = true;
			}
			else if (e.target.hasAttribute('data-collections-menu-trigger')) {
				id = menuIds.collections;
				isTrigger = true;
			}

			if (isTrigger && sn.modal) {
				sn.modal.open();
			}

			if (id) {
				const openTrigger = sn.root.querySelector(`[data-submenu-open="${id}"]`);
				if (openTrigger) {
					openTrigger.click();
				}
			}
		})

		function findDeepLinkIdByTitle(menuTitle) {
			if (!menuTitle) {
				return;
			}

			const titles = sn.root.querySelectorAll('.sidebar-nav-panel__header-title');
			if (!titles || !titles.length) {
				return;
			}

			const shopTitleElem = Array.from(titles).find(title => {
				const normalised = title.innerHTML.trim().toLowerCase();
				return normalised === menuTitle;
			});

			if (!shopTitleElem) {
				return;
			}

			const panel = sn.getPanel(shopTitleElem);
			if (!panel) {
				return;
			}

			let id = panel.dataset.submenu;
			return id;
		}
	}

	return sn;

})();


export default SidebarNav;



// WEBPACK FOOTER //
// ./scripts/modules/sidebar-nav.js